import { safeArray } from "@/helpers/functions/ArrayHelpers";
import { duckTypeExtract } from "@/helpers/functions/ObjectHelpers";
import { stripAccents } from "@/helpers/functions/StringHelpers";

function addGroupedValue(groups, key, value) {
  const values = groups.get(key) || [];
  values.push(value);
  groups.set(key, values);
}

export function normalizeStateValue(state) {
  const isObject = duckTypeExtract(state) === "object";
  const value = isObject ? state.sigla : state;

  if (typeof value !== "string") return null;

  const normalizedValue = value.trim().toUpperCase();
  return normalizedValue || null;
}

export function normalizeMunicipalityValue(municipality) {
  const isObject = duckTypeExtract(municipality) === "object";
  const value = isObject
    ? (municipality.id ?? municipality.value)
    : municipality;

  if (!value) return null;

  const normalizedValue = Number(value);
  return normalizedValue;
}

export function createTerritoryCatalog(territories) {
  const regioes = new Map();
  const estados = new Map();
  const municipios = new Map();
  const estadosPorRegiao = new Map();
  const municipiosPorEstado = new Map();
  const municipiosPorRegiao = new Map();

  for (const sourceRegion of safeArray(territories)) {
    const regionValue = String(sourceRegion?.regiao ?? "");
    if (!regionValue) continue;

    const region = { ...sourceRegion, regiao: regionValue };
    const states = safeArray(region.estados);
    delete region.estados;
    regioes.set(regionValue, region);

    for (const sourceState of states) {
      const stateValue = normalizeStateValue(sourceState);
      if (!stateValue) continue;

      const state = {
        ...sourceState,
        sigla: stateValue,
        regiao: regionValue,
      };
      const cities = safeArray(state.cidades);
      delete state.cidades;

      estados.set(stateValue, state);
      addGroupedValue(estadosPorRegiao, regionValue, state);

      for (const city of cities) {
        const municipalityId = normalizeMunicipalityValue(city);
        if (municipalityId === null) continue;

        const text = `${city?.text} · ${stateValue}`;

        const source = {
          ...city,
          id: municipalityId,
          value: municipalityId,
          text,
          searchText: stripAccents(text),
          uf: stateValue,
          regiao: regionValue,
        };

        municipios.set(String(municipalityId), source);
        addGroupedValue(municipiosPorEstado, stateValue, source);
        addGroupedValue(municipiosPorRegiao, regionValue, source);
      }
    }
  }

  return {
    regioes,
    estados,
    municipios,
    estadosPorRegiao,
    municipiosPorEstado,
    municipiosPorRegiao,
  };
}

export function getStatesByRegion(catalog, regionValue) {
  return catalog.estadosPorRegiao.get(String(regionValue)) || [];
}

export function getMunicipalitiesByState(catalog, stateValue) {
  const normalizedValue = normalizeStateValue(stateValue);

  return catalog.municipiosPorEstado.get(String(normalizedValue)) || [];
}

export function getMunicipalitiesByRegion(catalog, regionValue) {
  return catalog.municipiosPorRegiao.get(String(regionValue)) || [];
}
